<template>
  <w-dialog :dialog-state="dialogState" @handleClose="handleClose" :token='token' >
    <div slot="content" class="campus-code-container">
      <div class="close" @click="handleClose"><i class="iconfont iconx"></i></div>
      <div class="main_header" >
        <div :class="['header_img', downloadState ? '' : 'header_loading']">
          <span v-if="downloadState" class="iconfont iconwancheng"></span>
          <span v-else class="el-icon-loading"></span>
        </div>
        <div class="header_title" v-if="downloadState">下载完成</div>
        <div class="header_title" v-else>下载中</div>
      </div>

      <div class="online_cvs" v-if="!cv_invisibile && getisOnlineCv() && !(onlineCv && onlineCv.resume) && !jobLoading">
        <div class="cvs_title">设置在线简历</div>
        <div class="cvs_subtitle">将简历设置为HR可见，获得更多职业机会，求职效率翻倍</div>
        <div class="set_cvs" @click="goToCvs">立即设置</div>
      </div>

      <div class="main_list" v-if="similarList.length > 0 && !jobLoading">
        <div class="list_title">
          {{this.hasOurJob ? "专属职位" : "职位推荐"}}
        </div>
        <div class="list_subtitle">
          {{this.hasOurJob ?
            "经大数据科学评估，你的简历与该职位匹配度高达95%。超级简历诚邀你的加入，立即投递，简历直达面试官！"
            : "以下职位和你的简历匹配度95%"}}
        </div>
        <div class="list_item" v-if="!hasOurJob">
          <template v-for="(item, index) in similarList">
            <div class="item" :key='index' v-if="index < 6" @click="goToDetail(item.token)" data-gio-imp-track="cv_download_job_recommend" data-gio-track-cv_download_job_recommend="cv-editor">
              <div class="item_title"  @click="goToDetail(item.token)">
                <span class="title_cate"  @click="goToDetail(item.token)">{{item.job_post}}</span>
                <span class="title_money"  @click="goToDetail(item.token)">{{item.display_salary}}</span>
              </div>
              <div class="item_comp">
                <img :src="item.company_logo" alt="">
                <span>{{item.company_name}}</span>
              </div>
              <!--             <div class="item_comp"  @click="goToDetail(item.token)">{{item.company_name}}</div>-->
            </div>
          </template>
        </div>
        <div class="our_list_item" data-growing-container v-else>
          <template v-for="(item, index) in similarList">
            <div class="item" :key='index' v-if="index < 1" @click="goToDetail(item.token)" data-gio-imp-track="cv_download_job_ourjob" data-gio-track-cv_download_job_ourjob="cv-editor">
              <div class="item_title"  @click="goToDetail(item.token)">
                <div class="title-div">
                  <span class="title_cate"  @click="goToDetail(item.token)">
                    {{item.job_post}}
                  </span>
                  <span class="title-tag" v-for="tag in ['五险一金', '零食下午茶', '学习基金']" :key="tag">
                    {{tag}}
                  </span>
                </div>
                <span class="title_money"  @click="goToDetail(item.token)">{{item.salary}}</span>
              </div>
              <div class="item_subtitle">
                <span class="text">
                  <i class="iconfont iconmap-pin" />
                  {{ item.city }}
                </span>
                <span class="text">
                  <i class="iconfont iconbriefcase" />
                  {{ item.experience }}
                </span>
                <span class="text">
                  <i class="iconfont iconxiaohui" />
                  {{ item.degree }}
                </span>
              </div>
              <div class="item_last">
                <div class="item_hr">
                  <img src="https://photo.wondercv.com/image/lusihr/IMG_1195.JPG" alt="">
                  <div class="hr">
                    <div class="hr_name">
                      Lusi
                    </div>
                    <div class="hr_info">
                      超级简历 - HRBP
                    </div>
                  </div>
                </div>
                <div class="item_comp">
                  <div class="comp">
                    <div class="comp_name">
                      超级简历
                    </div>
                    <div class="comp_info">
                      互联网 · 民企 · 20人-99人
                    </div>
                  </div>
                  <img :src="item.company_logo" alt="">
                </div>
              </div>
              <!--             <div class="item_comp"  @click="goToDetail(item.token)">{{item.company_name}}</div>-->
            </div>
          </template>
        </div>
        <div class="list_btn" @click="goToJobs" v-if="!hasOurJob">查看更多职位</div>
        <div class="list_btn" @click="goToDetail(similarList[0].token)" v-else>立即投递</div>
      </div>
      <div class="main_list" v-if="jobLoading">
        <skeleton :options="{ moduleCount: 1, count: 4 }" style="margin-bottom: 24px"/>
      </div>
    </div>
  </w-dialog>
</template>

<script>
  import WDialog from '../../../../components/base/dialog'
  import skeleton from '@/components/base/skeleton';
  import api from '@/api'
  import {routerTo, get_tUser} from '@/assets/js/util';
  import {mapState} from "vuex";


  export default {
    name: 'campus-code',
    props: {
      dialogState: {
        type: Boolean,
        default: false
      },
      qrUrl: {
        type: String,
        default: ''
      },
      token: {
        type: String,
        default: ''
      },
      downloadState: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        similarList:[],//相似职位
        cv_invisibile: false, // 是否引导用户去设置在线简历
        onlineCv:{},  // 在线简历
        recommendOurJob: true, // 是否推荐我们自己的职位
        jobLoading: true,
        hasOurJob: false,
      }
    },
    mounted () {
    },
    computed: {
      ...mapState('cv', ['cvs'])
    },
    watch: {},
    components: {
      WDialog,
      skeleton
    },
    async created(){
      this.$store.dispatch('cv/getCvsList');
      // console.log(this.qrUrl,this.token,this.$route.params.token,api.cvsV2.cvsJobsRecommend())
      this.getJobs()
      let _c_t = get_tUser().c_t || '';
      // let res = await api.cvsV2.getOnlineCv(_c_t)
      // this.onlineCvs = res.code === 80120
      let res = await api.cvsV2.cvVisibility(_c_t);
      this.cv_invisibile = (res.data && res.data.cv_invisibile) || false;
      res = await api.cvsV2.getOnlineCv(this._c_t);
      this.onlineCv = res.data && res.data.resume || res.data || {};
    },
    methods: {
      // 获取简历是否可以生成在线简历
      getisOnlineCv() {
        let isTrue = false;
        let cvs = this.cvs;
        for (let i = 0; i < cvs.length; i++) {
          if (cvs[i].lang === 'cn' && cvs[i].can_editable && !cvs[i].is_mentor) {
            isTrue = true;
            break;
          }
        }
        return isTrue;
      },
      handleClose () {
        this.$emit('handleClose')
      },
      // 查看是否有Wondercv自己需要推荐的职位
      async getWondercvJob(token) {
        try {
          if (this.recommendOurJob) {
            let resumePredictedResultRes = await api.cvsEditor.getCvPredictedResult(token)
            let resumeCities = false
            let experience = 0
            let nodeLv2 = "1000000"
            if (resumePredictedResultRes && resumePredictedResultRes.code === 1000) {
              let resumePredictedResult = resumePredictedResultRes.data
              if (resumePredictedResult.expected_cities.includes("北京") || resumePredictedResult.predict_cities.includes("北京")) {
                resumeCities = true
              }
              nodeLv2 = (resumePredictedResult.result && resumePredictedResult.result.level2_id) || nodeLv2
              experience = resumePredictedResult.years_of_work_experience || experience
            } else {
              return []
            }
            let wondercvJobsRes = await api.jobs.getOurCompanyJobs()
            if (wondercvJobsRes && wondercvJobsRes.code === 1000) {
              let wondercvJobsData = (wondercvJobsRes.data && wondercvJobsRes.data.jobs) || []
              return wondercvJobsData.filter(function (item) {
                if ((nodeLv2.slice(0, 4) === item.profession_id.slice(0, 4))
                     // && (experience <= item.experience_max)
                     // && (experience >= item.experience_min)
                     // && resumeCities
                ) {
                  return item
                }
              })
            }
          } else {
            return []
          }
        } catch(err) {
          console.log(err)
          return []
        }
      },
      // 简历相关职位
      async getJobs (){
        if (this.recommendOurJob) {
          try {
            let res = await this.getWondercvJob(this.token)
            if (res && res.length > 0) {
              this.hasOurJob = true
              this.similarList = res
            }
          } catch(err) {
            console.log(err)
          }
        }
        if (!this.hasOurJob) {
          try {
            // 新推荐接口
            // let res = await api.cvsV2.cvsDownloadJobsRecommend({
            //   size: 6,
            //   page: 0,
            //   jd_flag: 1,
            //   cv_token: this.token,
            //   resume_flag: 1
            // })
            let res = await api.cvsV2.cvsJobsRecommend({
              size: 6,
              from: 0,
              jd_flag: 1,
              resume_token: this.token,
              resume_flag: 1
            })
            if(res.code === 1000) {
              this.similarList = (res && res.data && res.data.jobs) || []
            }
          } catch(err) {
            console.log(err)
            this.similarList = []
          }
        }
        this.jobLoading = false
      },
      // 去职位推荐
      goToJobs() {
        routerTo('/jobs/search','_blank')
      },
      // 去职位详情
      goToDetail (token) {
        routerTo(`/jobs/${token}.html`,'_blank')
      },
      // 设置在线简历
      goToCvs() {
        routerTo(`/cvs?origin=editor`)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/css/public";
  @keyframes loading {
    from{
      transform: rotate(0deg);
    }
    to{
      transform: rotate(360deg);
    }
  }
  @keyframes download {
    5%{
      transform: scale(0.1);
    }
    50%{
      transform: scale(1.15);
    }
    100%{
      transform: scale(1);
    }
    /*75%{*/
    /*  transform: scale(1.15);*/
    /*}*/
    /*100%{*/
    /*  transform: scale(1);*/
    /*}*/
  }
  .nojob {
    display: flex;
    align-items: center;
    width: 300px !important;
    height: 277px;
    background:rgba(255,255,255,1);
  }
  .campus-code-container1 {
    display: flex;
    align-items: center;
    width: 300px;
    height: 277px;
    background:rgba(255,255,255,1);
    .close {
      position: absolute;
      font-size: 18px;
      right: 24px;
      top: 20px;
      color: #9C9C9C;
      cursor: pointer;
    }
    .main_header {
      margin: 0 auto;
      width: 72px;
      height: 77px;
      display: flex;
      font-family:PingFangSC-Medium,PingFang SC;
      //background-color: chartreuse;
      .header_img {
        margin: 0 auto;
        width: 40px;
        height: 40px;
        border-radius: 20px;
        span {
          display: block;

          font-size: 40px;
          width: 40px;
          height: 40px;
          color: #FF6644;
        }
      }
      .header_title {
        margin-top: 10px;
        height:21px;
        font-size:18px;
        font-weight:500;
        color:rgba(64,64,64,1);
        line-height:21px;
        text-align: center;
      }

    }
  }
  .campus-code-container {
    box-sizing: border-box;
    padding-top: 52px;
    width:813px;
    // height:467px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 8px 0px rgba(0,0,0,0.13);
    border-radius:4px;
    .close {
      position: absolute;
      font-size: 20px;
      right: 24px;
      top: 20px;
      color: #9C9C9C;
      cursor: pointer;
      .iconfont{
        font-size: 20px!important;
      }
    }
    .main_header {
      margin: 0 auto;
      width: 72px;
      height: 77px;
      font-family:PingFangSC-Medium,PingFang SC;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      //background-color: chartreuse;
      .header_img {
        margin: 0 auto;
        width: 40px;
        height: 40px;
        border-radius: 20px;
        text-align: center;
        .el-icon-loading {
          font-size: 35px;
          width: 35px;
          height: 35px;
          color: #9c9c9c!important;
          animation: loading 1s linear infinite;
        }
        .iconwancheng{
          color: #ff6644;
          animation: download .5s linear;
        }
        span {
          display: inline-block;
          font-size: 40px;
          width: 40px;
          height: 40px;
          /*color: #FF6644;*/
        }
      }
      .header_title {
        margin-top: 10px;
        height:21px;
        font-size:18px;
        font-weight:500;
        color:rgba(64,64,64,1);
        line-height:21px;
        text-align: center;
      }

    }

    .online_cvs{
      margin: 22px auto;
      width: 740px;
      height: 40px;
      padding-bottom: 22px;
      border-bottom: 1px solid #f4f4f4;
      position: relative;
      .set_cvs{
        width: 60px;
        height: 20px;
        padding: 3px 15px;
        font-size: 14px;
        border-radius: 13px;
        line-height: 20px;
        text-align: center;
        color: #ff6644;
        border: 1px solid #ff6644;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-26px);
        cursor: pointer;
        &:hover{
          background-color: #ff6644;
          color: #fff;
        }
      }
      .cvs_title{
        margin-top: 16px;
        height:21px;
        font-size:16px;
        font-weight:500;
        color:rgba(64,64,64,1);
        line-height:21px;
      }
      .cvs_subtitle{
        margin: 5px 473px 0px 0px;
        height:14px;
        width: 100%;
        font-size:14px;
        font-weight:400;
        color:rgba(0,0,0,.45);
        line-height:14px;
      }
    }

    .main_list {
      margin: 22px auto 0;
      width: 740px;
      height: auto;
      padding-bottom: 32px;
      .list_title{
        margin-top: 16px;
        height:21px;
        font-size:16px;
        font-weight:500;
        color:rgba(64,64,64,1);
        line-height:21px;
      }
      .list_subtitle {
        margin: 5px 0px 0px 0px;
        width: 100%;
        height:14px;
        font-size:14px;
        font-weight:400;
        color:rgba(0,0,0,.45);
        line-height:14px;
      }
      .list_item {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 16px;
        width: 740px;
        //height: 188px;
        .item {
          margin-bottom: 8px;
          box-sizing: border-box;
          padding: 20px 17px;
          width: 240px;
          //height:90px;
          border-radius:3px;
          border:1px solid #F4F4F4;
          cursor: pointer;
          .item_title {
            display: flex;
            justify-content: space-around;
            align-items: center;
            .title_cate {
              display: inline-block;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              height: 18px;
              width: 153px;
              font-size:16px;
              font-weight:500;
              color:rgba(64,64,64,1);
              line-height:18px;
              vertical-align: middle;
            }
            .title_money {
              /*width: 80px;*/
              white-space: nowrap;
              text-align: right;
              display: inline-block;
              /*margin-left: 16px;*/
              font-size:14px;
              font-weight:500;
              line-height:16px;
              color:rgba(255,102,68,1);
            }
          }
          .item_comp {
            display: flex;
            flex: 1;
            height: 17px;
            align-items: center;
            margin-top: 10px;

            img{
              width: 15px;
              height: 15px;
              border: 1px solid #F4F4F4;
              object-fit: contain;
              border-radius: 2px;
              box-sizing: border-box;
            }
            span{
              display: inline-block;
              width: calc(100% - 20px);
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              font-size:12px;
              font-weight:300;
              color:rgba(64,64,64,1);
              margin-left: 5px;
            }
          }
          &:hover{
            /*box-shadow: 0 2px 18px 0 #ececec;*/
            .item_title .title_cate{
              color: rgba(255,102,68,1);
            }
          }
        }
      }
      .our_list_item {
        width: 100%;
        margin-top: 16px;
        .item {
          margin-bottom: 8px;
          box-sizing: border-box;
          padding: 20px 24px;
          width: 100%;
          //height:90px;
          border-radius:3px;
          border:1px solid #F4F4F4;
          cursor: pointer;
          .item_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .title-div {
              display: flex;
              align-items: center;
              .title_cate {
                height: 20px;
                font-size: 20px;
                font-weight: 500;
                color: #262A30;
                line-height: 20px;
              }
              .title-tag {
                height: 28px;
                background: #F9F9F9;
                border-radius: 15px;
                line-height: 28px;
                color: #404040;
                margin-left: 8px;
                padding: 0 12px;
                font-size: 14px;
              }
            }
            .title_money {
              /*width: 80px;*/
              // width: 75px;
              height: 20px;
              font-size: 20px;
              font-weight: 500;
              color: #FF6644;
              line-height: 20px;
            }
          }
          .item_subtitle {
            margin-top: 12px;
            .text {
              width: 28px;
              height: 20px;
              font-size: 14px;
              font-weight: 400;
              color: #606060;
              line-height: 20px;
              margin-right: 20px;
              .iconfont {
                height: 14px;
                width: 14px;
                font-size: 14px;
              }
            }
          }
          .item_last {
            display: flex;
            justify-content: space-between;
            margin-top: 18px;
            .item_hr {
              display: flex;
              align-items: center;
              img {
                height: 42px;
                width: 42px;
                border-radius: 21px;
                margin-right: 12px;
              }
              .hr {
                .hr_name {
                  height: 22px;
                  font-size: 16px;
                  font-weight: 500;
                  color: #333333;
                  line-height: 22px;
                }
                .hr_info {
                  height: 20px;
                  font-size: 14px;
                  font-weight: 400;
                  color: #606060;
                  line-height: 20px;
                }
              }
            }
            .item_comp {
              display: flex;
              align-items: center;
              .comp {
                .comp_name {
                  height: 16px;
                  font-size: 16px;
                  font-weight: 500;
                  color: #404040;
                  line-height: 16px;
                  margin-bottom: 8px;
                  text-align: right;
                }
                .comp_info {
                  height: 12px;
                  font-size: 12px;
                  font-weight: 400;
                  color: #9C9C9C;
                  line-height: 12px;
                  text-align: right;
                }
              }
              img{
                width: 42px;
                height: 42px;
                // border: 1px solid #F4F4F4;
                object-fit: contain;
                border-radius: 2px;
                box-sizing: border-box;
                margin-left: 12px;
              }
            }
          }
          &:hover{
            /*box-shadow: 0 2px 18px 0 #ececec;*/
            .item_title .title_cate{
              color: rgba(255,102,68,1);
            }
          }
        }
      }
      .list_btn {
        margin: 30px auto 0;
        width:242px;
        height:36px;
        background:rgba(255,102,68,1);
        border-radius:4px;
        text-align: center;
        line-height: 36px;
        font-size:14px;
        font-weight:400;
        color:rgba(255,255,255,1);
        cursor: pointer;
        &:hover{
          background-color: #FF8569;
        }
      }
    }

  }
</style>
